// extracted by mini-css-extract-plugin
export default {"root":"tVCr-","llama":"bDX7D","big":"_1_UBQ","small":"dn4e3"};